import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { A11yModule } from '@angular/cdk/a11y';
import { FormsModule } from '@angular/forms';

import { ChamadaRecursoContextualComponent } from './chamada-recurso-contextual/chamada-recurso-contextual.component';
import { ExplorarRecursosComponent } from './explorar-recursos/explorar-recursos.component';
import { PreviaRecursoComponent } from './previa-recurso/previa-recurso.component';

@NgModule({
  declarations: [ChamadaRecursoContextualComponent, ExplorarRecursosComponent, PreviaRecursoComponent],
  imports: [CommonModule, FormsModule, RouterModule, A11yModule],
  exports: [ChamadaRecursoContextualComponent, ExplorarRecursosComponent]
})
export class RecursosModule {}
